import { t } from 'i18next';
import * as yup from 'yup';
import { AnyObjectSchema } from 'yup';

import { ICompanySettings } from 'auth/types';
import { getEmptyErrorMessage, numberSchemaWithTransform } from 'core/yup';
import { upsertCustomerQuoteSchema } from 'quotes/components/CustomerQuoteUpsert';
import { QuoteEntityType } from 'quotes/enums';

interface IProps {
  isCreatingQuote: boolean;
  entityType?: QuoteEntityType;
  companySettings?: ICompanySettings;
  isAlternateVersionEnabled?: boolean;
}

export const reelLinesSchema = () =>
  yup.object().shape({
    lines: yup.array().of(
      yup.object().shape({
        quantity: numberSchemaWithTransform()
          .label(t('labelQuantity'))
          .nullable()
          .required(getEmptyErrorMessage(t('labelQuantity')))
          .moreThan(0, t('errorInvalidQuantity')),
        reelRowId: yup.string().required(),
        uom: yup
          .string()
          .label(t('labelUom'))
          .nullable()
          .required(getEmptyErrorMessage(t('labelUom'))),
      })
    ),
  });

// An existing quote leaves only the lines to validate; creating one validates the create-quote
// form as well, as the add-from-BoM flow does.
export const getSchema = ({
  isCreatingQuote,
  entityType = QuoteEntityType.QUOTE,
  companySettings,
  isAlternateVersionEnabled = false,
}: IProps) => {
  if (!isCreatingQuote) {
    return reelLinesSchema();
  }

  return (
    upsertCustomerQuoteSchema({
      entityType,
      companySettings,
      isEdit: false,
      isAlternateVersionEnabled,
    }) as AnyObjectSchema
  ).concat(reelLinesSchema());
};
